/* eslint-disable */
import React, { useState, useEffect } from "react";
import axios from "axios";

import LoanOfficerCard from "./LoanOfficerCard";

export default function App() {
  const [query, setQuery] = useState("");
  const [error, setError] = useState("");
  const [loanOfficers, setLoanOfficers] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const validateQuery = (input) => {
    const zipMatches = input.match(/\b\d{5}(?:-\d{4})?\b/g) || [];
    const invalidZipMatches = input.match(/\b\d{1,4}\b|\b\d{6,}\b/g) || [];

    if (invalidZipMatches.length > 0) {
      return "Please type a valid zipcode";
    }

    if (/^\s*$/.test(input)) {
      return "TODO: Better Validation Message Here";
    }

    return ""; // valid
  };

    const triggerSearch = async (searchValue) => {
        const validationError = validateQuery(searchValue);

        if (validationError) {
            setError(validationError);
            return;
        }

        setError("");
        setIsLoading(true);

        try {
            const response = await axios.get(`/api/loanofficers?query=${encodeURIComponent(searchValue)}`);
            setLoanOfficers(response.data);
        } catch (err) {
            setError("Search failed. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const value = params.get('query');

        if (value) {
            setQuery(value);
            triggerSearch(value);
        }
    }, []);

  return (
      <div className="loan-officer-landing">
          <div className="search-container">
              <label>Search by Location</label>
              <div className="input-container">
                  <input
                      type="text"
                      value={query}
                      onChange={(e) => {
                          //const value = e.target.value.replace(/[^a-zA-Z0-9]/g, ''); // strip non-alphanumeric
                          setQuery(e.target.value);
                      }}
                      onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                              e.preventDefault();
                              triggerSearch(query);
                          }
                      }}
                      placeholder="Enter Your Zip Code or State Code"
                  />
                  <button className="clear-button" onClick={() => setQuery('')}>X</button>
              </div>
          </div>

          {error && <p style={{ color: "red" }}>{error}</p>}
            {isLoading && (
                <div className="loading-state">
                    <div className="spinner" />
                    <p>Searching for Loan Experts...</p>
                </div>
          )}

          {loanOfficers?.length > 0 && !isLoading &&
              <div className="loan-officer-grid">
                {loanOfficers.map((loanOfficer, index) => (
                    <LoanOfficerCard key={index} loanOfficer={loanOfficer} />
                ))}
            </div>
          }

          {loanOfficers?.length === 0 && !isLoading && ( 
            <h3 className="mt-4">No Loan Experts found.</h3>
          )}
    </div>
  );
}
